import type { ReactNode } from "react";

/**
 * Full-area "something broke" message with the error text and a slot for
 * recovery actions. Router-agnostic: apps read the error (e.g. React Router's
 * `useRouteError`) and pass it in as `details`.
 */
export function ErrorState({
  title = "Something went wrong",
  message = "This page hit an error and couldn't finish loading. Reloading usually fixes it; if it keeps happening, send the details below to engineering.",
  details,
  actions,
}: {
  title?: string;
  message?: string;
  details?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="max-w-xl">
      <h1 className="mb-2 text-2xl font-bold text-amber-600">{title}</h1>
      <p className="mb-4 text-sm text-gray-700">{message}</p>
      {details && (
        <pre className="mb-5 overflow-x-auto rounded-md border border-gray-200 bg-gray-50 p-3 text-xs whitespace-pre-wrap text-gray-800">
          {details}
        </pre>
      )}
      {actions && <div className="flex items-center gap-4">{actions}</div>}
    </div>
  );
}
